<template>
  <div class="send-form">
    <div class="f-group">
      <div class="f-title">{{ $t("asset.recipientAddress") }}</div>
      <div class="f-input">
        <input
          type="text"
          autocomplete="off"
          @input="onRecipientInput"
          v-model="recipient"
          :placeholder="$t('asset.recipientAddressPlaceholder')"
        />
      </div>
    </div>

    <div class="f-group">
      <div class="f-title">{{ $t("asset.sendAmount") }}</div>
      <div class="f-input-btn">
        <input
          type="text"
          autocomplete="off"
          @input="onAmountInput"
          v-model="amount"
          :placeholder="$t('asset.sendAmountPlaceholder')"
        />
        <div class="btn" @click="onTotalClick">{{ $t("asset.sendTotal") }}</div>
      </div>
      <div class="f-tips">
        {{ $t("asset.availableBalance") }}
        <span class="amount">{{
          formatTokenWithoutSymbol(availableBalance)
        }}</span>
        {{ symbol }}
      </div>
    </div>

    <div class="f-group">
      <div class="f-title">{{ $t("asset.recipientMemo") }}</div>
      <div class="f-input">
        <input
          type="text"
          autocomplete="off"
          @input="onMemoInput"
          v-model="memo"
          :placeholder="$t('asset.recipientMemoPlaceholder')"
        />
      </div>
    </div>

    <div class="f-group">
      <div class="f-btn">
        <div class="btn" @click="onConfirm">{{ $t("asset.confirm") }}</div>
        <div class="btn-fee">
          {{ $t("asset.transferFee") }}{{ formatToken(fee, "DNA") }} +
          {{ formatToken(price_per_kbyte, "DNA") }} {{ $t("asset.feePerKb") }}
        </div>
      </div>
    </div>
    <dna-spin v-if="isLoading"></dna-spin>
    <!-- 输入密码 -->
    <dna-password-modal
      :isShow="isPasswordModalShow"
      @closed="isPasswordModalShow = false"
      @confirm="onPasswordConfirm"
    ></dna-password-modal>

    <!-- 手续费，金额提示框 -->
    <dna-modal
      :isShow="confirmShow"
      @closed="confirmShow = false"
      :isHeaderShow="false"
      :isMaskClosable="false"
    >
      <div class="modal-content">
        <div class="title">
          {{ $t("asset.sendConfirmSend") }}
          <span>{{ formatToken(confirmAmountStr) }}</span>
        </div>
        <!-- <div class="c-item"><div class="c-text">Send: </div><div class="c-value">{{confirmAmountStr}}</div></div> -->
        <div class="c-item">
          <div class="c-text">{{ $t("asset.sendConfirmTo") }}</div>
          <div class="c-value">{{ confirmToStr }}</div>
        </div>
        <div class="c-item" v-if="confirmMemoStr">
          <div class="c-text">{{ $t("asset.sendConfirmMemo") }}</div>
          <div class="c-value">{{ confirmMemoStr }}</div>
        </div>
        <div class="c-item">
          <div class="c-text">{{ $t("asset.sendConfirmFee") }}</div>
          <div class="c-value">{{ formatToken(confirmFeeStr, "DNA") }}</div>
        </div>
      </div>
      <div class="modal-footer">
        <dna-button @click="onFeeConfirmClick">{{
          $t("asset.sendConfirmConfirm")
        }}</dna-button>
        <dna-button :type="'cancel'" @click="onFeeCancelClick">{{
          $t("asset.sendConfirmCancel")
        }}</dna-button>
      </div>
    </dna-modal>
  </div>
</template>

<script>
import wsSubscribe from "@/req/wsSubscribe.js";
import tx from "@/req/tx.js";
import wallet from "@/util/wallet.js";
import UTIL from "@/util/util.js";
import regex from "@/util/regex.js";
import ERROR from "@/util/error.js";
import DATA from "@/data/data.js";
import BigNumber from "bignumber.js";
export default {
  // 参数
  data() {
    return {
      recipient: "",
      amount: "",
      memo: "",
      isPasswordModalShow: false,
      isLoading: true,
      isBtnLoading: false,
      symbol: DATA.DLP_TOKEN_SYMBOL,
      fee: 0,
      price_per_kbyte: 0,
      tx_kbyte: 0,

      confirmToStr: "",
      confirmAmountStr: "",
      confirmMemoStr: "",
      confirmFeeStr: "",
      confirmShow: false,
      confirmCb: () => {},
    };
  },
  async mounted() {
    let that = this;
    await that.load();
  },
  methods: {
    async load() {
      let that = this;
      if (!that.address) {
        that.$router.push("/").catch((err) => {});
        return;
      }
      await that.loadFee();
      that.isLoading = false;
    },
    async loadFee() {
      let that = this;
      let feeResults = await wsSubscribe.wsFetchOperationFees(["transfer"]);
      //console.log(feeResults)
      if (feeResults.length) {
        that.fee = feeResults[0].fee;
        that.price_per_kbyte = feeResults[0].price_per_kbyte;
      }
    },
    resetInput() {
      this.recipient = "";
      this.amount = "";
      this.memo = "";
    },
    onRecipientInput(e) {
      let value = e.target.value;
      this.recipient = value;
    },
    onMemoInput(e) {
      let value = e.target.value;
      this.memo = value;
    },
    onAmountInput(e) {
      let value = e.target.value;
      this.amount = value;
    },
    onTotalClick() {
      this.amount = this.formatTokenWithoutSymbol(this.availableBalance);
    },
    formatToken(val, symbol = DATA.DLP_TOKEN_SYMBOL) {
      return UTIL.formatDlpToken(val, [], 4, symbol); //
    },
    formatTokenWithoutSymbol(val) {
      return UTIL.formatDlpToken(val, [], 4, ""); //
    },
    onFeeConfirmClick() {
      this.confirmShow = false;
      this.confirmCb();
    },
    onFeeCancelClick() {
      this.confirmShow = false;
    },
    transferFeeConfirm(toStr, amountStr, memoStr, feeStr, cb) {
      let that = this;
      that.confirmToStr = toStr;
      that.confirmAmountStr = amountStr;
      that.confirmMemoStr = memoStr;
      that.confirmFeeStr = feeStr;
      that.confirmShow = true;
      that.confirmCb = cb;
    },
    async getInputObject(valudateAccountExist = false) {
      let that = this;
      //检查recipient是否为正确账户
      if (!that.recipient) {
        that.$Message.error({
          background: true,
          duration: 3,
          content: that.$t("asset.recipientAddressPlaceholder"),
        });
        return null;
      }
      if (!regex.isBtsNameLegal(that.recipient, true)) {
        that.$Message.error({
          background: true,
          duration: 3,
          content: that.$t("global.usernameStartWithLowerCase"),
        });
        return null;
      }
      if (that.recipient == that.address) {
        that.$Message.error({
          background: true,
          duration: 3,
          content: that.$t("asset.recipientAddressCanNotBeYouSelf"),
        });
        return null;
      }
      if (valudateAccountExist) {
        this.isLoading = true;
        let accRes = await wsSubscribe.wsFetchBtsGetAccountDetail(
          that.recipient
        );
        //console.log(accRes);
        this.isLoading = false;
        if (!accRes || !accRes.length || !accRes[0]) {
          that.$Message.error({
            background: true,
            duration: 3,
            content: that.$t("asset.recipientNotExist"),
          });
          return null;
        }
      }

      //检查amout是否正确
      if (!this.amount) {
        that.$Message.error({
          background: true,
          duration: 3,
          content: that.$t("asset.sendAmountPlaceholder"),
        });
        return null;
      }
      let amt = new BigNumber(this.amount.replace(/,/g, ""));
      if (amt.isNaN() || amt.isLessThanOrEqualTo(0)) {
        that.$Message.error({
          background: true,
          duration: 3,
          content: that.$t("asset.withdrawalAmountIncorrect"),
        });
        return null;
      }
      // console.log("amt:" + amt);
      amt = UTIL.toUnit(amt.toString());
      // console.log("amt:" + amt);
      // console.log("availableBalance:" + that.availableBalance);
      if (new BigNumber(amt).isGreaterThan(that.availableBalance)) {
        //TODO:
        that.$Message.error({
          background: true,
          duration: 3,
          content: that.$t("asset.assetNotEnough"),
        });
        return null;
      }

      let memo = that.memo || "";
      return {
        recipient: this.recipient,
        amount: amt,
        memo: memo,
      };
    },
    async onConfirm() {
      let that = this;
      let inputObj = await that.getInputObject(true);
      if (inputObj) {
        this.isPasswordModalShow = true;
        //alert(JSON.stringify(inputObj));
      }
    },
    // 密码确认
    async onPasswordConfirm(pw) {
      let that = this;
      try {
        let inputObj = await that.getInputObject(false);
        if (!inputObj) {
          //this.isPasswordModalShow = true;
          return;
        }
        if (inputObj.memo && inputObj.memo.toLowerCase() == pw.toLowerCase()) {
          that.isLoading = false;
          that.$Message.error({
            background: true,
            duration: 5,
            content: that.$t("asset.doUsePasswordInMemo"),
          });
          return;
        }
        this.isPasswordModalShow = false;

        // TODO: 用户输入判断
        let userInfo = that.$store.state.userInfo;
        let mnemonic = UTIL.decryptKey(userInfo.key, pw);
        if (!mnemonic) {
          that.isLoading = false;
          that.$Message.error({
            background: true,
            duration: 5,
            content: that.$t("global.passwordError"),
          });
          return;
        }
        this.isLoading = true;
        if (that.net == "bts") {
          // BTS网络下，查询该ID对应信息
          let walletInfo = wallet.getAccountInfo(mnemonic, that.net);
          //console.log("privateKey:" + walletInfo.privateKey.toString());
          let transferResult = await tx.transferDNA(
            walletInfo.privateKey,
            userInfo.name,
            inputObj.recipient,
            {
              amount: inputObj.amount,
              asset: DATA.DLP_TOKEN_SYMBOL,
            },
            inputObj.memo,
            true
          );
          // console.log(transferResult.operations[0][1]);
          let feeObj = transferResult.operations[0][1].fee;
          console.log(that.availableBalance);
          console.log(feeObj.amount);
          console.log(inputObj.amount);
          if (
            new BigNumber(that.availableBalance).isLessThan(
              new BigNumber(feeObj.amount).plus(inputObj.amount)
            )
          ) {
            inputObj.amount = new BigNumber(that.availableBalance)
              .minus(feeObj.amount)
              .toNumber();
            console.log(inputObj.amount);
          }
          that.transferFeeConfirm(
            inputObj.recipient,
            inputObj.amount,
            inputObj.memo,
            feeObj.amount,
            function () {
              that.isLoading = true;
              tx.transferDNA(
                walletInfo.privateKey,
                userInfo.name,
                inputObj.recipient,
                {
                  amount: inputObj.amount,
                  asset: DATA.DLP_TOKEN_SYMBOL,
                },
                inputObj.memo,
                false
              )
                .then((transferResult) => {
                  that.isLoading = false;
                  //console.log("transfer result:" + JSON.stringify(transferResult));
                  let txId =
                    transferResult && transferResult.length
                      ? transferResult[0].id
                      : "";
                  that.$Message.success({
                    background: true,
                    duration: 3,
                    content: that.$t("asset.transferSuccess") + " " + txId,
                  });
                  that.refreshBalance();
                })
                .catch((err) => {
                  that.isLoading = false;
                  let msg =
                    ERROR.getCustomMessage(err, that.$t.bind(that)) ||
                    that.$t("global.networkError");
                  that.$Message.error({
                    background: true,
                    duration: 5,
                    content: msg,
                  });
                });
            }
          );
        }
        if (that.net == "sub") {
          // SUB网络，直接存储
        }
        this.resetInput();
        this.isLoading = false;
        return;
      } catch (err) {
        that.isLoading = false;
        let msg =
          ERROR.getCustomMessage(err, that.$t.bind(that)) ||
          that.$t("global.networkError");
        that.$Message.error({
          background: true,
          duration: 5,
          content: msg,
        });
      }
    },
    refreshBalance() {
      let that = this;
      setTimeout(() => {
        that.$store.commit("setUserManualRefresh", new Date().getTime());
      }, 1000);
    },
  },
  computed: {
    net() {
      return this.$store.state.net;
    },
    address() {
      return (
        this.$store.state.userInfo.name || this.$store.state.userInfo.address
      );
    },
    availableBalance() {
      let balances = this.$store.state.userInfo.balances || [];
      let coreAsset = balances.find(
        (it) => it.asset_type == DATA.DLP_TOKEN_ASSET_ID
      );
      //console.log("coreAsset:" + JSON.stringify(coreAsset));
      if (coreAsset) {
        this.isLoading = false;
        return coreAsset.balance;
      } else {
        return 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./AssetSendForm.less");
</style>